import styles from "./ChatHeader.module.css";
import Avatar from "../Avatar/Avatar";

interface ChatHeaderProps {
  botName: string;
  botAvatarURL: string | null;
  onMinimize: () => void;
  onClose: () => void;
  visibleBotAvatar: boolean;
  minimizeButtonImage: string;
  closeButtonImage: string;
}

const ChatHeader = ({
  botName,
  botAvatarURL,
  onMinimize,
  onClose,
  visibleBotAvatar,
  minimizeButtonImage,
  closeButtonImage
}: ChatHeaderProps) => {
  return (
    <section className={styles.header}>
      <div className={styles.left}>
        {visibleBotAvatar && botAvatarURL && (
          <Avatar src={botAvatarURL} />
        )}
        <span className={styles.title}>{botName}</span>
      </div>
      <section className={styles.buttonWrapper}>
        <button className={styles.minimizeButton} onClick={onMinimize} aria-label="Minimera chatt">
          <img src={minimizeButtonImage} alt="Minimera chatt" className={styles.minimizeIcon} />
        </button>
        <button className={styles.closeButton} onClick={onClose} aria-label="Stäng chatt">
          <img src={closeButtonImage} alt="Stäng chatt" className={styles.closeIcon} />
        </button>
      </section>
    </section>
  );
};

export default ChatHeader;
